/* eslint-disable no-restricted-syntax */
import { all, call, put, takeLatest, takeLeading, } from 'redux-saga/effects';

import * as apicore from "services/core";
import * as apistorage from "services/storage";
import * as type from './constant';
import * as action from './action';

function* getListItems({ params, selfRole }) {
  try {
    
    const data = [];
    let p = 0;
    let tp = 0;
    do {
      const { results, page, totalPages } = yield call(apicore.getTaskRequest, { ...params, page: p + 1, limit: 50 }, selfRole);
      data.push(...results)
      p = page;
      tp = totalPages;
    } while (p < tp);
    
    yield put(action.getTaskSuccess(data, `${params.year}-${params.month}`, selfRole));

  } catch (error) {
    yield put(action.getTaskError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* addItem({ payload, selfRole }) {
  try {

    const documentReferenceResponse = yield call(apistorage.uploadRequest, [payload.document_reference], 'task');
    const [docId] = documentReferenceResponse;
    /* eslint-disable-next-line no-param-reassign */
    payload.document_reference = docId;

    const response = yield call(apicore.addTaskRequest, payload, selfRole);
    yield put(action.addTaskSuccess(response));

  } catch (error) {
    yield put(action.manipulationTaskError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* updateItem({ id, payload, selfRole }) {
  try {

    const response = yield call(apicore.updateTaskRequest, id, payload, selfRole);
    yield put(action.updateTaskSuccess(response));

  } catch (error) {
    yield put(action.manipulationTaskError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* deleteItem({ ids, selfRole }) {
  try {

    for (const id of ids) {
      yield call(apicore.deleteTaskRequest, id, selfRole);
    }
    
    yield put(action.deleteTaskSuccess(true));

  } catch (error) {
    yield put(action.manipulationTaskError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* cancelItem({ id, selfRole }) {
  try {

    const response = yield call(apicore.cancelTaskRequest, id, selfRole);
    yield put(action.cancelTaskSuccess(response));

  } catch (error) {
    yield put(action.manipulationTaskError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* cancelAsignee({ id, asigneeId, selfRole }) {
  try {

    const response = yield call(apicore.cancelAsigneeRequest, id, asigneeId, selfRole);
    yield put(action.cancelAsigneeSuccess(response));

  } catch (error) {
    yield put(action.manipulationTaskError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

export function* watchGetList() {
  yield takeLatest(type.GET, getListItems);
}
export function* watchAddList() {
  yield takeLeading(type.ADD, addItem);
}
export function* watchUpdateItem() {
  yield takeLeading(type.UPDATE, updateItem);
}
export function* watchDeleteItem() {
  yield takeLeading(type.DELETE, deleteItem);
}
export function* watchCancelItem() {
  yield takeLeading(type.CANCEL, cancelItem);
}
export function* watchCancelAsignee() {
  yield takeLeading(type.CANCEL_ASIGNEE, cancelAsignee);
}

export default function* rootSaga() {
  yield all([
    watchGetList(),
    watchUpdateItem(),
    watchAddList(),
    watchDeleteItem(),
    watchCancelItem(),
    watchCancelAsignee(),
  ]);
}
